import React, { useCallback } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import Mgm from '../components/Mgm';

export default () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const referrerCustomerId = params.get('referrerCustomerId');
  const mgmCampaign = params.get('mgmCampaign');
  const history = useHistory();

  if (!referrerCustomerId) return <Redirect to="/" />;

  const onRegisterStartClick = useCallback(() => {
    history.push('/register', {
      afterLoginUrl: '/',
      isMgm: true,
      mgmCampaign,
      referrerCustomerId,
    });
  }, [referrerCustomerId, mgmCampaign, history]);

  return (
    <Mgm onRegisterStartClick={onRegisterStartClick} />
  );
};
